export const ItemsPerPageDefault = 48;

export const mappingTypes = {
  card: 'card',
  accordion: 'accordion',
  table: 'table',
  profileTeaser: 'profile-teaser',
}

export const layouts = {
  standard: 'standard',
  compact: 'compact',
  horizontal: 'horizontal',
};

export const CardDataFields = {
  imageUrl: '',
  badges: '',
  pretitle: '',
  title: '',
  subtitle: '',
  body: '',
  links: '',
}

export const AccordionDataFields = {
  imageUrl: '',
  title: '',
  badge: '',
  body: '',
  markdown: '',
  descriptionList: '',
  descriptionListLabels: '',
  links: '',
}

export const TableDataFields = {
  columns: '',
  labels: '',
};

export const ProfileTeaserDataFields = {
  title: '',
  job_role: '',
  specialization: '',
  institution_name: '',
  profile_image_url: '',
  profile_page_url: '',
  links: [],
}
